const reverseUrl = (urlName, ...params) => DJ_CONST.reverse[urlName](...params);

export const navigateTo = (...params) => {
    window.location = reverseUrl(...params);
};

export default reverseUrl;
